document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pw-product').forEach(function (section) {
    initGallery(section);
    initQuantity(section);
    initVariantPicker(section);
  });

  function initGallery(section) {
    var mainImg = section.querySelector('[data-pw-main-image] img');
    var thumbs = section.querySelectorAll('[data-pw-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initQuantity(section) {
    var input = section.querySelector('.pw-product__qty-input');
    var minus = section.querySelector('[data-pw-qty-minus]');
    var plus = section.querySelector('[data-pw-qty-plus]');
    if (!input) return;

    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, val - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
      });
    }
  }

  function initVariantPicker(section) {
    var jsonEl = section.querySelector('[data-pw-product-json]');
    var variantInput = section.querySelector('[data-pw-variant-id]');
    var addBtn = section.querySelector('[data-pw-add-btn]');
    var addBtnText = section.querySelector('[data-pw-add-btn-text]');
    var priceEl = section.querySelector('.pw-product__price');
    if (!jsonEl || !variantInput) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var optionGroups = section.querySelectorAll('.pw-product__option');
    if (!optionGroups.length) return;

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group, i) {
        var active = group.querySelector('.pw-product__option-value.is-selected');
        selected[i] = active ? active.getAttribute('data-pw-option-value') : null;
      });
      return selected;
    }

    function findMatchingVariant(selected) {
      return variants.find(function (variant) {
        return selected.every(function (val, i) {
          return variant.options[i] === val;
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;

      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      if (priceEl && variant.price !== undefined) {
        var formatted = (variant.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
        });
        var priceSpan = priceEl.querySelector('span');
        if (priceSpan) priceSpan.textContent = formatted;
      }
    }

    section.querySelectorAll('.pw-product__option-value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.pw-product__option');
        group.querySelectorAll('.pw-product__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        var selected = getSelectedOptions();
        var match = findMatchingVariant(selected);
        updateForVariant(match);
      });
    });
  }
});

document.querySelectorAll('.pw-product').forEach(function (sectionEl) {
  const mainImg = sectionEl.querySelector('[id^="pw-main-img-"]');
  const thumbs = Array.from(sectionEl.querySelectorAll('[data-pw-thumb]'));
  const navBtns = sectionEl.querySelectorAll('[data-pw-nav]');

  if (!mainImg || thumbs.length === 0) return;

  function setActiveByIndex(index) {
    const thumb = thumbs[index];
    if (!thumb) return;
    mainImg.src = thumb.getAttribute('data-full');
    thumbs.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }

  navBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const currentIndex = thumbs.findIndex(t => t.classList.contains('is-active'));
      let nextIndex;
      if (btn.dataset.pwNav === 'next') {
        nextIndex = (currentIndex + 1) % thumbs.length;
      } else {
        nextIndex = (currentIndex - 1 + thumbs.length) % thumbs.length;
      }
      setActiveByIndex(nextIndex);
    });
  });
});